export default "__VITE_ASSET__D_DzJpez__"